import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
let OrganizationCustomFieldModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('boolean'), _dec5 = attr('boolean'), _dec6 = attr('string'), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec0 = attr('boolean'), _dec1 = attr('boolean'), _dec10 = attr('boolean'), _dec11 = attr('boolean'), _dec12 = attr('boolean'), _dec13 = attr('boolean'), _dec14 = attr('boolean'), _dec15 = belongsTo('contact_state', {
  inverse: null,
  async: false
}), _dec16 = belongsTo('product_state', {
  inverse: null,
  async: false
}), _dec17 = belongsTo('project_state', {
  inverse: null,
  async: false
}), _dec18 = belongsTo('event_state', {
  inverse: null,
  async: false
}), _dec19 = belongsTo('workhour_state', {
  inverse: null,
  async: false
}), _dec20 = hasMany('custom_field_definition', {
  inverse: 'organization_custom_field',
  async: false
}), _dec21 = belongsTo('organization', {
  inverse: 'organization_custom_fields',
  async: false
}), _dec22 = attr('boolean', {
  defaultValue: false
}), _class = class OrganizationCustomFieldModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "data_type", _descriptor2, this);
    _initializerDefineProperty(this, "rank", _descriptor3, this);
    _initializerDefineProperty(this, "disabled", _descriptor4, this);
    _initializerDefineProperty(this, "always_visible", _descriptor5, this);
    _initializerDefineProperty(this, "model_related", _descriptor6, this);
    _initializerDefineProperty(this, "is_editable", _descriptor7, this);
    _initializerDefineProperty(this, "is_deletable", _descriptor8, this);
    _initializerDefineProperty(this, "in_contact", _descriptor9, this);
    _initializerDefineProperty(this, "in_product", _descriptor0, this);
    _initializerDefineProperty(this, "in_project", _descriptor1, this);
    _initializerDefineProperty(this, "in_event", _descriptor10, this);
    _initializerDefineProperty(this, "in_workhour", _descriptor11, this);
    _initializerDefineProperty(this, "in_invoice", _descriptor12, this);
    _initializerDefineProperty(this, "in_expense", _descriptor13, this);
    _initializerDefineProperty(this, "in_payment", _descriptor14, this);
    _initializerDefineProperty(this, "contact_state", _descriptor15, this);
    _initializerDefineProperty(this, "product_state", _descriptor16, this);
    _initializerDefineProperty(this, "project_state", _descriptor17, this);
    _initializerDefineProperty(this, "event_state", _descriptor18, this);
    _initializerDefineProperty(this, "workhour_state", _descriptor19, this);
    _initializerDefineProperty(this, "custom_field_definitions", _descriptor20, this);
    _initializerDefineProperty(this, "organization", _descriptor21, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor22, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data_type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "disabled", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "always_visible", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "model_related", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "is_editable", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "is_deletable", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "in_contact", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "in_product", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "in_project", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "in_event", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "in_workhour", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "in_invoice", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "in_expense", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "in_payment", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "contact_state", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "product_state", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "project_state", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "event_state", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "workhour_state", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "custom_field_definitions", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { OrganizationCustomFieldModel as default };
//# sourceMappingURL=organization-custom-field.js.map
